/* eslint-disable @typescript-eslint/no-explicit-any */
import type { FormEvent } from 'react'
import type { Control } from 'react-hook-form'

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from './ui/form'
import { Input, type InputProps } from './ui/input'
type Props<T> = InputProps & {
  label: string
  errorMessage?: string
  control: Control<any>
  name: Extract<keyof T, string>
  onChangeValue?: (value: FormEvent<HTMLInputElement>) => void
}

export function InputFormComponent<T>({
  control,
  name,
  label,
  onChangeValue,
  errorMessage,
  ...rest
}: Props<T>) {
  const { required } = rest

  const hasErrorMessage = !!errorMessage
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col flex-1">
          {label && (
            <FormLabel className="flex font-normal">
              {label} {required && <p className="text-red-500">*</p>}
            </FormLabel>
          )}
          <FormControl>
            <Input
              onClick={(e) => {
                const inputElement = e.target as HTMLInputElement
                inputElement.select()
              }}
              onChange={(e) => {
                onChangeValue?.(e)
                field.onChange(e)
              }}
              value={field.value}
              defaultValue={field.value}
              {...rest}
            />
          </FormControl>
          {hasErrorMessage && (
            <FormMessage className="text-red-500">{errorMessage}</FormMessage>
          )}
        </FormItem>
      )}
    />
  )
}
